<div class="pill-search" [ngStyle]="customStyles">
  <span class="search-icon"></span>
  <input
    type="text"
    [placeholder]="placeholder"
    [formControl]="searchControl"
  />
  @if(searchControl.value) {
  <button type="button" class="clear-button" (click)="clear()" aria-label="Clear search">
    <mat-icon>close</mat-icon>
  </button>
  }
</div>
